const ManualIcon = ({ color = "#4D4D4D" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <rect x="5.33398" y="4" width="20" height="26.6667" fill="white" />
      <rect
        x="5.02626"
        y="2.14149"
        width="21.0556"
        height="27.7222"
        rx="1.34259"
        stroke={color}
        strokeWidth="1.61111"
      />
      <path
        d="M17.9715 22.2239C17.7517 22.4437 17.4819 22.5536 17.1622 22.5536C16.8425 22.5536 16.5728 22.4437 16.353 22.2239C16.1332 22.0041 16.0233 21.7343 16.0233 21.4146C16.0233 21.0949 16.1332 20.8251 16.353 20.6053C16.5728 20.3855 16.8425 20.2756 17.1622 20.2756C17.4819 20.2756 17.7517 20.3855 17.9715 20.6053C18.1913 20.8251 18.3012 21.0949 18.3012 21.4146C18.3012 21.7343 18.1913 22.0041 17.9715 22.2239Z"
        fill={color}
      />
      <path
        d="M17.8816 18.1775H16.1132C16.1132 17.3382 16.2581 16.6638 16.5478 16.1542C16.8375 15.6447 17.2821 15.1302 17.8816 14.6106C18.3811 14.191 18.7607 13.7863 19.0205 13.3967C19.2803 13.007 19.4101 12.5924 19.4101 12.1528C19.4101 11.5733 19.2003 11.0987 18.7807 10.729C18.3611 10.3594 17.8116 10.1745 17.1323 10.1745C16.5328 10.1745 16.0133 10.3294 15.5737 10.6391C15.1341 10.9488 14.8044 11.3835 14.5846 11.943L12.9961 11.3435C13.3358 10.4843 13.8803 9.80985 14.6296 9.32029C15.3789 8.83072 16.2431 8.58594 17.2222 8.58594C18.3611 8.58594 19.2753 8.90565 19.9646 9.54509C20.654 10.1845 20.9987 11.0338 20.9987 12.0928C20.9987 12.6923 20.8688 13.2418 20.609 13.7414C20.3493 14.2409 19.9097 14.7505 19.2903 15.27C18.6109 15.8295 18.2063 16.3241 18.0764 16.7537C17.9465 17.1833 17.8816 17.6579 17.8816 18.1775Z"
        fill={color}
      />
      <rect
        x="7.99805"
        y="1.33594"
        width="1.33333"
        height="29.3333"
        fill={color}
      />
    </svg>
  );
};

export default ManualIcon;
